<script setup lang="ts">
import {Model} from "@/app/Model";
let model: Model = Model.getReactiveInstance();
</script>

<template>
  <h2>Ciao {{model.user.profile.firstname}}!</h2>
  <p>Scegli dal menu a sinistra la sezione su cui operare.<br>Buon lavoro!</p>
</template>

<style scoped>

</style>